import {Component} from '@angular/core';

@Component({
  selector: 'form-header',
  template: `<div class="form-group text-primary"><h3><ng-content></ng-content></h3></div>`
})
export class FormHeaderCmp {

}
